// extracted by mini-css-extract-plugin
export default {"price":"P8-z","onSale":"Q8-z","msrpLabelPrice":"R8-z","msrpLabel":"S8-z","originalPrice":"T8-z","percentOff":"U8-z"};